import React from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  maxHeight: "80vh",
  overflow: "auto",
};

const FoundElementsModal = ({
  open,
  onClose,
  foundElements,
  selectedElementId,
  onElementSelect,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="found-elements-modal">
      <Box sx={ModalStyle}>
        <Typography id="found-elements-modal" variant="h6" component="h2" mb={2}>
          All Found Elements
        </Typography>

        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={selectedElementId || ""}
            onChange={(e) => {
              const elementId = e.target.value;
              const element = foundElements.find((el) => Object.keys(el)[0] === elementId);
              if (element) {
                onElementSelect(elementId, element[elementId]);
              }
            }}
          >
            {foundElements.map((element, index) => {
              const elementId = Object.keys(element)[0];
              const html = element[elementId];

              return (
                <Box key={elementId} mb={2} p={2} border="1px solid #e0e0e0" borderRadius={1}>
                  <FormControlLabel
                    value={elementId}
                    control={<Radio />}
                    label={
                      <Box>
                        <Typography variant="subtitle2" gutterBottom>
                          Element {index + 1} (ID: {elementId})
                        </Typography>
                        <Box
                          sx={{
                            fontFamily: "monospace",
                            backgroundColor: "#f5f5f5",
                            padding: "8px",
                            borderRadius: "4px",
                            overflowX: "auto",
                            fontSize: "0.75rem",
                            maxHeight: "80px",
                            overflowY: "auto",
                          }}
                        >
                          {html}
                        </Box>
                      </Box>
                    }
                  />
                </Box>
              );
            })}
          </RadioGroup>
        </FormControl>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={onClose} sx={{ ml: 2 }}>
            Select
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FoundElementsModal;
